module.exports = __webpack_public_path__ + "img/gif.0df49b4b.png";